import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const AdminReportView = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState([]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    useEffect(() => {
        fetchReportData(Id)
    }, []);

    const fetchReportData = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getReportSchoolwiseForAdminSale&schlId=${id}`);
            const updatedData = response?.data?.data?.map((item) => {
                const igst = parseFloat(item.igst || 0);
                const cgst = parseFloat(item.cgst || 0);
                const sgst = parseFloat(item.sgst || 0);

                return {
                    ...item, // spread existing item properties
                    totgst: igst + cgst + sgst // add new key
                };
            });

            setFormData(updatedData);
            // console.log(response?.data);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const totqty = formData?.reduce((acc, sum) => acc + parseFloat(sum.totissqty), 0);
    const totamt = formData?.reduce((acc, sum) => acc + parseFloat(sum.netamt), 0);
    const totgst = formData?.reduce((acc, sum) => acc + parseFloat(sum.totgst), 0);

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Admin Sale Report View</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <table style={{ textAlign: 'center' }}>
                                <thead>
                                    <th>Sr.No.</th>
                                    <th>Date</th>
                                    <th>Bill No.</th>
                                    <th>School Code</th>
                                    <th>Total Qty.</th>
                                    <th>Total Amt.</th>
                                    <th>Total GST.</th>
                                </thead>

                                <tbody>
                                    {formData?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.DT}</td>
                                            <td>{item.billNo}</td>
                                            <td>{item.schlcd}</td>
                                            <td>{item.totissqty}</td>
                                            <td>{item.netamt}</td>
                                            <td>{item.totgst}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>Total</td>
                                        <td>{totqty}</td>
                                        <td>{totamt}</td>
                                        <td>{totgst}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default AdminReportView;
